"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.PreferenceClientBuilder = void 0;
const preference_client_1 = require("../preference-client");
const preference_http_adapter_1 = require("../../adapters/preference-http.adapter");
const preference_body_parser_1 = require("../../custom-parsers/preference-body.parser");
const simple_logger_1 = require("../../logger/simple.logger");
const feature_flags_1 = require("../../helpers/feature-flags");
class PreferenceClientBuilder {
    static getClient(config) {
        if (!config.loggerService) {
            config.loggerService = PreferenceClientBuilder.getLoggerService();
        }
        const httpAdapter = new preference_http_adapter_1.PreferenceHttpAdapter(config, 'User Preferences Client  SDK');
        return new preference_client_1.PreferenceClient(httpAdapter, new preference_body_parser_1.PreferenceBodyParser(config), new feature_flags_1.FeatureFlags(httpAdapter), config, typeof window === 'undefined' ? undefined : window.sessionStorage);
    }
    static getLoggerService() {
        if (PreferenceClientBuilder.loggerService) {
            return PreferenceClientBuilder.loggerService;
        }
        if (typeof window === 'undefined') {
            return null;
        }
        PreferenceClientBuilder.loggerService = new simple_logger_1.SimpleLogger();
        // TODO: Check how to imoport logger-lib in browser
        // const { LoggerServiceFactory } = require('@greatmindsorg/dp-logger-lib');
        // PreferenceClientBuilder.loggerService =
        //   LoggerServiceFactory.createLoggerService({ level: 'info' });
        return PreferenceClientBuilder.loggerService;
    }
}
exports.PreferenceClientBuilder = PreferenceClientBuilder;
//# sourceMappingURL=preference-client.builder.js.map